import { Controller } from "stimulus";
import { initAutocomplete } from "../init/init_autocomplete";

export default class extends Controller {
  static targets = ["addressInput"];

  connect() {
    console.log("Address field controller connected");
    this.setupDatalistInputs();

    // Initialize Google Places Autocomplete
    if (this.hasAddressInputTarget) {
      initAutocomplete();
    }
  }

  setupDatalistInputs() {
    // Get all datalist inputs
    const datalistInputs = this.element.querySelectorAll("input[list]");

    // Add event listeners to each datalist input
    datalistInputs.forEach(input => {
      input.addEventListener("input", this.onDatalistInput.bind(this));
      input.addEventListener("change", this.onDatalistChange.bind(this));
    });
  }

  selectSavedAddress(event) {
    // Get address data from clicked element
    const addressId = event.currentTarget.dataset.addressId;
    const addressValue = event.currentTarget.dataset.addressValue;
    const addressFull = event.currentTarget.dataset.addressFull;

    // Find inputs more reliably instead of using targets
    const addressInput = this.element.querySelector(".address-input");
    const addressIdInput = this.element.querySelector(".address-id-input");

    if (!addressInput) {
      console.error(
        "Address input not found. Make sure your HTML includes an input with class 'address-input'"
      );
      return;
    }

    if (!addressIdInput) {
      console.error(
        "Address ID input not found. Make sure your HTML includes an input with class 'address-id-input'"
      );
      return;
    }

    // Update the values
    addressInput.value = addressValue;
    addressIdInput.value = addressId;

    // Add visual indication that an address is selected
    this.element.querySelectorAll(".address-item").forEach(item => {
      item.classList.remove("selected-address");
    });
    event.currentTarget.classList.add("selected-address");

    console.log(`Selected address ID: ${addressId}`);
    console.log(`Selected address value: ${addressValue}`);

    // Prevent default to avoid any potential form submission
    event.preventDefault();
  }

  onDatalistInput(event) {
    // When typing in the datalist input, enable the address input
    const addressInput = this.element.querySelector(".address-input");
    if (addressInput) {
      addressInput.disabled = false;
    }
  }

  onDatalistChange(event) {
    const selectedAddress = event.target.value;
    const addressInput = this.element.querySelector(".address-input");

    if (!addressInput) {
      console.error("Address input field not found");
      return;
    }

    if (selectedAddress) {
      // Find the datalist option that was selected to get its value and data attributes
      const datalist = document.getElementById(
        event.target.getAttribute("list")
      );
      const option = Array.from(datalist.options).find(
        opt => opt.value === selectedAddress
      );

      if (option) {
        const addressId = option.dataset.addressId;
        const addressIdInput = this.element.querySelector(".address-id-input");

        if (addressIdInput && addressId) {
          addressIdInput.value = addressId;
        }
      }

      addressInput.value = selectedAddress;
    } else {
      // If input is cleared
      addressInput.value = "";
      const addressIdInput = this.element.querySelector(".address-id-input");
      if (addressIdInput) {
        addressIdInput.value = "";
      }
    }
  }

  clearAddressInputs() {
    const addressInput = this.element.querySelector(".address-input");
    const addressIdInput = this.element.querySelector(".address-id-input");

    if (addressInput) {
      addressInput.value = "";
    }

    if (addressIdInput) {
      addressIdInput.value = "";
    }

    // Clear selected state from address items
    this.element.querySelectorAll(".address-item").forEach(item => {
      item.classList.remove("selected-address");
    });
  }
}
